let channelData = {
  "name": "MOMDAUGHTERKITCHEN Channel ",
  "description": "MOMDAUGHTERKITCHEN is a channel for Food Enthusiasts",
  /* "tag": 'Heavenly Tour Through Foods', */
  "tag": 'Spreading Love and Joy Through Cooking',
  "socialLinks": [
    {
      "name": "youtube",
      "no": "1",
      "url": "https://www.youtube.com/@momdaughterkitchen23",
      "className": "fa fa-youtube"
    }
  ],
  "copywrite": "Copyright © MOMDAUGHTERKITCHEN",
  "address": "India",
  "website": "#",
  "skillsDescription": "Your skills here",
  "photos": [
    {
      "name": "React JS",
      "class": "devicon-react-original",
      "level": "60"
    },
    {
      "name": "HTML 5",
      "class": "devicon-html5-plain",
      "level": "95"
    },
    {
      "name": "CSS 3",
      "class": "devicon-css3-plain",
      "level": "95"
    },
    {
      "name": "Angular",
      "class": "devicon-angularjs-plain",
      "level": "80"
    },
    {
      "name": "TypeScript",
      "class": "devicon-typescript-plain",
      "level": "90"
    },
    {
      "name": "JavaScript",
      "class": "devicon-javascript-plain",
      "level": "70"
    },
    {
      "name": "Sass",
      "class": "devicon-sass-original",
      "level": "75"
    },
    {
      "name": "Bootstrap",
      "class": "devicon-bootstrap-plain",
      "level": "85"
    },
    {
      "name": "Git",
      "class": "devicon-git-plain",
      "level": "65"
    }
  ]
}

export default channelData;